const DEEP_RESEARCH_MODELS = new Set([
  'competidor', 'competidor-2', 'competidor-3',
  'sabia-4', 'sabia-4-thinking', 'sabiazinho-4', 'sabia-5',
]);

export const supportsDeepResearch = (model: string): boolean =>
  DEEP_RESEARCH_MODELS.has(model);

// Contas @maritaca.ai conversam sempre com o Sabiá 5, sem seletor; as demais
// começam no Sabiá 4 Thinking, com o toggle Pensamento.
export const INTERNAL_CHAT_MODEL = 'sabia-5';
export const DEFAULT_CHAT_MODEL = 'sabia-4-thinking';

export const isInternalAccount = (email?: string): boolean =>
  !!email?.trim().toLowerCase().endsWith('@maritaca.ai');

export const chatModelFor = (email?: string): string =>
  isInternalAccount(email) ? INTERNAL_CHAT_MODEL : DEFAULT_CHAT_MODEL;

// Modelos que raciocinam antes de responder: o pré-pass sintético do
// sabia-4-thinking e o raciocínio nativo do Sabiá 5.
export const chatModelReasons = (model: string) =>
  model === 'sabia-4-thinking' || model === 'sabia-5';

// Esforço do raciocínio nativo (Sabiá 5), escolhido na barra de digitação.
export type ReasoningEffort = 'none' | 'low' | 'medium' | 'xhigh';
export const DEFAULT_REASONING_EFFORT: ReasoningEffort = 'xhigh';
export const REASONING_EFFORTS: { value: ReasoningEffort; label: string; hint: string }[] = [
  { value: 'none', label: 'Sem raciocínio', hint: 'Responde direto, mais rápido' },
  { value: 'low', label: 'Baixo', hint: 'Pensa pouco antes de responder' },
  { value: 'medium', label: 'Médio', hint: 'Equilíbrio entre rapidez e cuidado' },
  { value: 'xhigh', label: 'Alto', hint: 'Pensa mais; melhor para tarefas difíceis' },
];
const REASONING_EFFORT_KEY = 'maritalk-reasoning-effort';

export const chatModelHasEffort = (model: string) => model === 'sabia-5';

export const reasoningEffortLabel = (effort: ReasoningEffort) =>
  REASONING_EFFORTS.find((e) => e.value === effort)?.label ?? effort;

export const loadReasoningEffort = (): ReasoningEffort => {
  try {
    const saved = localStorage.getItem(REASONING_EFFORT_KEY);
    if (REASONING_EFFORTS.some((e) => e.value === saved)) return saved as ReasoningEffort;
  } catch { /* storage bloqueado: fica o padrão */ }
  return DEFAULT_REASONING_EFFORT;
};

export const saveReasoningEffort = (effort: ReasoningEffort) => {
  try { localStorage.setItem(REASONING_EFFORT_KEY, effort); } catch { /* ignora */ }
};

// O modelo pensa neste envio? No Sabiá 5 depende do esforço escolhido.
export const turnReasons = (model: string, effort: ReasoningEffort) =>
  chatModelReasons(model) && !(chatModelHasEffort(model) && effort === 'none');

// Nome do modelo mostrado na barra (só leitura).
const CHAT_MODEL_LABELS: Record<string, string> = {
  'sabia-5': 'S5',
  'sabia-4-thinking': 'Sabiá 4 Thinking',
  'sabia-4': 'Sabiá 4',
  'sabiazinho-4': 'Sabiazinho 4',
};
export const chatModelLabel = (model: string) => CHAT_MODEL_LABELS[model] ?? model;
